import React from 'react';
import { UserCardSpokenLanguages } from 'ha/components.legacy/UserCard/UserCardCountryOrLanguage/UserCardSpokenLanguages';
import { UserCardCountry } from 'ha/components.legacy/UserCard/UserCardCountryOrLanguage/UserCardCountry';
import { Variant } from './types';

interface Props {
  spokenLanguages: string[];
  location: string;
  variant: Variant;
}

const UserCardCountryOrLanguage: React.FC<Props> = ({
  spokenLanguages,
  location,
  variant = 'div',
}) => {
  return spokenLanguages.length ? (
    <UserCardSpokenLanguages
      variant={variant}
      spokenLanguages={spokenLanguages}
    />
  ) : (
    <UserCardCountry variant={variant} location={location} />
  );
};

export { UserCardCountryOrLanguage };
